<template lang="html">
  <v-container class="text-center fill-height">
    <v-row align="center">
      <v-col>
        <h1 class="display-2">Whoops, 404</h1>

        <p>The page you were looking for does not exist</p>

        <v-btn outlined color="primary"
          @click.stop="$router.push('/')"
        >Get me out of here!</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
